import { Badge, Box, CardBody, CardFooter, CardHeader, IconButton, useDisclosure } from '@chakra-ui/react'
import { CircularLoading } from "../../molecules/loading/CircularLoading";
import { TableLayout } from "../../template/table/TableLayout";
import { TableRowLayout } from "../../template/table/TableRowLayout";
import { PageTransitionBtn } from "../../atoms/button/PageTransitionBtn";
import { useParams } from "react-router-dom";
import { DarkShadowCard } from "../../molecules/card/DarkShadowCard";
import { CardHeading } from "../../molecules/card/CardHeading";
import { RiFileTextLine } from "react-icons/ri";
import { useFetchStaffSurveyQuestions } from "../../../hooks/restaurantStaff/useFetchStaffSurveyQuestions";
import { memo } from 'react';
import { useDeleteWithMutate } from '../../../hooks/useDeleteWithMutate';
import { DeleteIcon } from '@chakra-ui/icons';
import { DeleteModal } from '../../molecules/DeleteModal';
import { KeyedMutator } from 'swr';


export const StaffSurveyQuestions = () => {
  const { restaurantId } = useParams()
  const { surveyQuestions, isLoading, mutate } = useFetchStaffSurveyQuestions(restaurantId)
  if (isLoading || !surveyQuestions) return <CircularLoading />
  const headers = ['質問', '回答数', ''];
  const rows = surveyQuestions.map((surveyQuestion) => (
    <TableRowLayout
      key={surveyQuestion.id}
      childrenList={[
        surveyQuestion.question,
        surveyQuestion.answer_count,
        surveyQuestion.is_selected ? (
          <Badge colorScheme='green'>使用中</Badge>
        ) : (
          <StaffSurveyQuestionDeleteModal id={surveyQuestion.id} mutate={mutate} question={surveyQuestion.question} />
        )
      ]}
    />
  ));
  return (
    <Box m='auto' w={{ base: '100%', md: '80%' }}>
      <DarkShadowCard>
        <CardHeader>
          <CardHeading icon={<RiFileTextLine size="20px" />} heading='従業員アンケート一覧'/>
        </CardHeader>
        <CardBody py={2}>
          <TableLayout headers={headers} rows={rows || []} size='sm' />
        </CardBody>
        <CardFooter>
          <PageTransitionBtn path={'register'} text="新規登録" />
        </CardFooter>
      </DarkShadowCard>
    </Box>
  );
};


const StaffSurveyQuestionDeleteModal = memo(({id, mutate, question}: {id: string, mutate: KeyedMutator<any>, question: string}) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const onSubmit = useDeleteWithMutate(`restaurant_staff/survey/questions/${id}/`, onClose, mutate)
  return (
    <>
      <IconButton
        variant='ghost'
        colorScheme='red'
        aria-label='Delete'
        icon={<DeleteIcon boxSize="20px" />}
        size='xs'
        onClick={(e) => { e.stopPropagation(); onOpen(); }}
      />
      <DeleteModal
        isOpen={isOpen}
        onClose={onClose}
        deleteTarget={question}
        onSubmit={onSubmit}
      />
    </>
  );
});
